@if (fieldSet.includes(ServiceDataFields.HistoryOfCancer)) {
  <ng-container formGroupName="cancerHistory">
    <div class="row">
      <div class="col-12 col-md-6 mb-3">
        <div class="row align-items-center">
          <div class="col-12 col-sm-6 col-md-4 mb-1">
            <label for="cancerHistory">{{
              'serviceData.form.cancerHistory' | translate
            }}</label>
          </div>
          <div class="col-12 col-sm-6 col-md-8">
            <div class="form-check form-check-inline form-check-lg">
              <input
                id="cancerHistoryYes"
                class="form-check-input me-2"
                type="radio"
                formControlName="hasHistory"
                [attr.data-cy]="
                  ServiceDataFields.HistoryOfCancer + '-radio-yes'
                "
                [value]="true"
              />
              <label class="form-check-label" for="cancerHistoryYes">
                {{ 'common.yes' | translate }}
              </label>
            </div>
            <div class="form-check form-check-inline form-check-lg">
              <input
                id="cancerHistoryNo"
                class="form-check-input me-2"
                type="radio"
                formControlName="hasHistory"
                [attr.data-cy]="ServiceDataFields.HistoryOfCancer + '-radio-no'"
                [value]="false"
              />
              <label class="form-check-label" for="cancerHistoryNo">
                {{ 'common.no' | translate }}
              </label>
            </div>
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-12 col-sm-6 col-md-8">
            <app-validation-error
              for="hasHistory"
              translations="validation.generic"
              [attr.data-cy]="
                ServiceDataFields.HistoryOfCancer + '-validation-error'
              "
            ></app-validation-error>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 mb-3 align-self-center">
        @if (form.get('cancerHistory.hasHistory').value) {
          <div class="row align-items-center">
            <div class="col-12 col-sm-6 col-md-4 mb-1">
              <label for="historyOfCancerStatus">
                {{
                  'serviceData.form.historyOfCancerStatus.status' | translate
                }}</label
              >
            </div>
            <div class="col-12 col-sm-6 col-md-8 d-flex gap-3">
              <div class="form-check form-check-lg d-flex align-items-center">
                <input
                  id="historyOfCancerStatusRecovered"
                  class="form-check-input me-2"
                  type="radio"
                  formControlName="status"
                  [attr.data-cy]="
                    ServiceDataFields.HistoryOfCancer + '-sub-radio-recovered'
                  "
                  [value]="cancerHistoryStatus.Recovered"
                />
                <label
                  class="form-check-label d-flex"
                  for="historyOfCancerStatusRecovered"
                >
                  {{
                    'serviceData.form.historyOfCancerStatus.recovered'
                      | translate
                  }}
                </label>
              </div>
              <div class="form-check form-check-lg d-flex align-items-center">
                <input
                  id="historyOfCancerStatusCurrentlyAffected"
                  class="form-check-input me-2"
                  type="radio"
                  formControlName="status"
                  [attr.data-cy]="
                    ServiceDataFields.HistoryOfCancer +
                    '-sub-radio-currently-affected'
                  "
                  [value]="cancerHistoryStatus.CurrentlyAffected"
                />
                <label
                  class="form-check-label d-flex"
                  for="historyOfCancerStatusCurrentlyAffected"
                >
                  {{
                    'serviceData.form.historyOfCancerStatus.currentlyAffected'
                      | translate
                  }}
                </label>
              </div>
            </div>
          </div>
          <div class="row justify-content-end">
            <div class="col-12 col-sm-6 col-md-8">
              <app-validation-error
                for="status"
                translations="serviceData.form.validation.cancerHistory"
                [attr.data-cy]="
                  ServiceDataFields.HistoryOfCancer + '-sub-validation-error'
                "
              ></app-validation-error>
            </div>
          </div>
        }
      </div>
    </div>
  </ng-container>

  @if (isCancerRecovered$ | async) {
    <div class="row justify-content-end mb-3">
      <div class="notes col-12 col-md-10" data-cy="cancerRecovery-note">
        {{ 'serviceData.form.cancerRecovery' | translate }}
      </div>
    </div>
  }
}
